import { v4 as uuidv4 } from 'uuid'
import { apiPath } from 'settings/xhr/navigatorAPI'
import { entryPointId } from 'settings/app/constants'
import React, { createContext, useContext, useRef } from 'react'
import { getCookieValueByName, setCookie } from 'settings/app/helpers'


export const CostEstimateContext = createContext({})

export const CostEstimateProvider = ({ children }) => {
  // refs prevents unnecessary renders
  let { current: contractId } = useRef()
  let { current: uid } = useRef(getCookieValueByName('navigatoren_uid'))
  const windowRef = useRef()

  const handleCostEstimate = (newContractId) => {
    if (!uid) {
      // generate unique id for user auth
      const generatedUid = uuidv4()
      uid = generatedUid
      // set cookie for user auth, expires in 30 days
      setCookie('navigatoren_uid', generatedUid, 30)
    }

    if (
      !windowRef.current || // no window exists open a new one
      contractId !== newContractId || // call open if contractId changes
      windowRef.current?.closed // call open if window was closed
    ) {
      windowRef.current = window.open(
        `${ apiPath }careservice/calculation?pkId=${ newContractId }&uid=${ uid }`,
        'costEstimateWindow', 
        'width=1200,height=768'
      )
      contractId = newContractId
    } else {
      windowRef.current.focus()
    }
  }

  if (localStorage.getItem('entryPoint') !== entryPointId.CARESERVICES) {
    return children
  }

  return (
    <CostEstimateContext.Provider
      value={{ handleCostEstimate, contractId, uid }}>
      {children}
    </CostEstimateContext.Provider>
  )
}

export const useCostEstimate = () => {
  const context = useContext(CostEstimateContext)
  return context
}

export const CostEstimateConsumer = ({ children }) => (
  <CostEstimateContext.Consumer>
    {(context) => children(context)}
  </CostEstimateContext.Consumer>
)
